import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clone } from 'ramda';
import { AsyncCreatable } from 'react-select';
import { getMaterialsListByVendor } from "../../api/task";
import fields from "./fields";
import Input from '../Input';
import Currency from '../Currency';
import styles from './styles';

export default class SuppliesLogMaterialItem extends Component {
  state = {
    fields: clone(fields),
  };

  constructor(props) {
    super(props);
    this.removeItem = this.removeItem.bind(this);
    this.changeField = this.changeField.bind(this);
  }

  removeItem(e) {
    e.preventDefault();
    this.props.onChange('delete');
  }

  changeField(field, value) {
    this.props.onChange(field, value);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.vendorId !== prevProps.vendorId) {
      this.setState({ forceMaterial: true });
    } else if (this.state.forceMaterial) {
      this.setState({ forceMaterial: false });
    }
  }

  render() {
    const { name, material_id, quantity, price, subtotal } = this.props.material;
    const loadOptions = (filter) => getMaterialsListByVendor(filter, this.props.vendorId);
    const disabled = this.props.disabled;
    const finFieldsVisible = this.props.financialFieldsVisible;
    const finFieldsDisabled = this.props.financialFieldsDisabled || disabled;

    return (
      <div className="row">
        <div className={finFieldsVisible ? "col col-lg-5 col-md-4 col-sm-4" : "col col-9"}>
          {this.state.forceMaterial ? null : <AsyncCreatable
            disabled={!this.props.vendorId || disabled}
            cacheOptions
            defaultOptions
            clearable={false}
            placeholder='Choose material...'
            loadOptions={loadOptions}
            onChange={(newItem) => this.changeField('material', newItem)}
            value={name ? {
              label: name,
              value: material_id,
            } : null}
          />}
        </div>
        {this.props.isRemovable && (
          <div className="col col-lg-2 col-md-3 col-sm-3">
            <Input
              field={{ ...this.state.fields.quantity, value: quantity }}
              onChange={(name, field) => this.changeField('quantity', field.value)}
              disabled={disabled}
            />
          </div>
        )}
        {finFieldsVisible && this.props.isRemovable && (
          <div className="col col-2">
            <Currency
              forceUpdate
              field={{ ...this.state.fields.price, value: price }}
              onChange={(name, field) => this.changeField('price', field.value)}
              disabled={finFieldsDisabled}
            />
          </div>
        )}
        {finFieldsVisible && this.props.isRemovable && (
          <div className="col col-2">
            <Currency
              forceUpdate
              disabled
              field={{ ...this.state.fields.subtotal, value: subtotal }}
            />
          </div>
        )}
        {!disabled && (this.props.isRemovable ? (
          <div className="col col-1 d-flex align-items-center">
            <button className="btn ui-btn" style={styles.removeBtn} onClick={this.removeItem}>
              <i className="material-icons">clear</i>
            </button>
          </div>
        ) : (
          <div className="col col-1 d-flex align-items-center">&nbsp;</div>
        ))}
      </div>
    );
  }
}

SuppliesLogMaterialItem.propTypes = {
  isRemovable: PropTypes.bool,
  material: {
    id: PropTypes.number,
    material_id: PropTypes.number,
    name: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.string,
    subtotal: PropTypes.string,
  },
  onChange: PropTypes.func,
  vendorId: PropTypes.number,
  financialFieldsVisible: PropTypes.bool,
  financialFieldsDisabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/SuppliesLogMaterials/item.js